import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-memory-details',
  templateUrl: './memory-details.component.html',
  styleUrl: './memory-details.component.scss'
})
export class MemoryListComponent {
  galleryFolderId: any;
  constructor(  
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
  ) {
    this.route.params.subscribe((params: any) => {
      this.galleryFolderId = params['gallery_folder_id'] || '';
    });
  }

  photosOrVideo(num: any) {
    this.router.navigate(["memory-photo-video/" + num + '/' + this.galleryFolderId]);
  }

}
